import { useToolbarStore } from '../../../store/VitalStore';
//UI
import AdminList from './AdminList';
import { API_BASE_URL } from '../../../store/constans';
import { useDispatch, useSelector } from 'react-redux';
import { MessageCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { getConfigsThunk, initialStateConfig } from '../../../store/slices/catalogs/config.slice';
import { isWithinBusinessHours, Toast } from '../../../resources/utils';

const NavLeftPublic = () => {

  const { isToolbarOpen, closeToolbar } = useToolbarStore((state) => state);
  const user = JSON.parse(localStorage.getItem("userInfo"));
  const [dentroHorario, setDentroHorario] = useState(true)
  const { items } = useSelector(state => state.configurations);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getConfigsThunk());
    return () => {
      dispatch(initialStateConfig())
    }
  }, []);

  useEffect(() => {
    if (items.length > 0) {
      const dentroHorario = isWithinBusinessHours(items[0].soporte_desde, items[0].soporte_hasta);
      if (!dentroHorario) {
        setDentroHorario(dentroHorario);
      }
    }
  }, [items]);

  return (
    <div
      className={`text-gray-500 font-sans shadow-md fixed z-10 top-0 bottom-0 shadow-black/30 md:translate-x-0 transition-all w-60 bg-cover bg-fixed ${isToolbarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
    >
      <div className="absolute top-0 left-0 w-full h-full bg-slate-100 "></div>
      <div className="flex items-center justify-center p-5 gap-2 my-5 h-16 z-20 relative">
        <img className="object-contain h-[80px] md:h-[70px] 2xl:h-[80px] " src={API_BASE_URL + user?.logo} alt="logo" />
      </div>
      <ul className="flex flex-col h-full items-start justify-start w-full gap-2 z-20 relative ">
        <AdminList />
      </ul>

      <div className=' flex flex-col p-4  w-full justify-start items-center text-[12px] absolute z-30 bottom-5 right-0'>
        <p className='text-gray-500'>¿Problemas con el proceso?</p>
        <button
          className="bg-green-50 cursor-pointer flex items-center gap-2 border-green-500 text-green-600 hover:bg-green-100 hover:text-green-700 transition rounded-2xl px-4 py-2 text-sm shadow-sm"
          onClick={() => {
            if (dentroHorario) {
              window.open(`https://wa.me/593${items[0]?.numero_soporte}`, '_blank')
            } else {
              Toast.fire({ icon: 'warning', title: `El ahorario de soporte es de ${items[0].soporte_desde + ' a ' + items[0].soporte_hasta}` });
            }
          }}
        >
          Contáctanos
          <MessageCircle className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default NavLeftPublic;
